export default "__VITE_ASSET__Dp6sJC_U__"